export interface IProductConstant {
  OVERWRITE_META_TAG: {
    PRODUCT_TITLE: string;
    PRODUCT_DESCRIPTION: string;
  };
  SCHEMA_MARKUP: {
    ADDITIONAL_PROPERTY: string;
    AGGREGATE_RATING: string;
    AUDIENCE: string;
    AWARD: string;
    BRAND: string;
    CATEGORY: string;
    COLOR: string;
    DEPTH: string;
    GTIN: string;
    GTIN_12: string;
    GTIN_13: string;
    GTIN_14: string;
    GTIN_8: string;
    HAS_MERCHANT_RETURN_POLICY: string;
    HEIGHT: string;
    IS_ACCESSORY_OR_SPARE_PART_FOR: string;
    IS_CONSUMABLE_FOR: string;
    IS_RELATED_TO: string;
    IS_SIMILAR_TO: string;
    ITEM_CONDITION: string;
    LOGO: string;
    MANUFACTURER: string;
    MATERIAL: string;
    MODEL: string;
    MPN: string;
    NSN: string;
    OFFERS: string;
    PRODUCT_ID: string;
    PRODUCTION_DATE: string;
    PURCHASE_DATE: string;
    RELEASE_DATE: string;
    REVIEW: string;
    SKU: string;
    SLOGAN: string;
    WEIGHT: string;
    WIDTH: string;
  };
}

const PRODUCT: IProductConstant = {
  OVERWRITE_META_TAG: {
    PRODUCT_TITLE: 'Product Title',
    PRODUCT_DESCRIPTION: 'Product Description',
  },
  SCHEMA_MARKUP: {
    ADDITIONAL_PROPERTY: 'additionalProperty',
    AGGREGATE_RATING: 'aggregateRating',
    AUDIENCE: 'audience',
    AWARD: 'award',
    BRAND: 'brand',
    CATEGORY: 'category',
    COLOR: 'color',
    DEPTH: 'depth',
    GTIN: 'gtin',
    GTIN_12: 'gtin12',
    GTIN_13: 'gtin13',
    GTIN_14: 'gtin14',
    GTIN_8: 'gtin8',
    HAS_MERCHANT_RETURN_POLICY: 'hasMerchantReturnPolicy',
    HEIGHT: 'height',
    IS_ACCESSORY_OR_SPARE_PART_FOR: 'isAccessoryOrSparePartFor',
    IS_CONSUMABLE_FOR: 'isConsumableFor',
    IS_RELATED_TO: 'isRelatedTo',
    IS_SIMILAR_TO: 'isSimilarTo',
    ITEM_CONDITION: 'itemCondition',
    LOGO: 'logo',
    MANUFACTURER: 'manufacturer',
    MATERIAL: 'material',
    MODEL: 'model',
    MPN: 'mpn',
    NSN: 'nsn',
    OFFERS: 'offers',
    PRODUCT_ID: 'productID',
    PRODUCTION_DATE: 'productionDate',
    PURCHASE_DATE: 'purchaseDate',
    RELEASE_DATE: 'releaseDate',
    REVIEW: 'review',
    SKU: 'sku',
    SLOGAN: 'slogan',
    WEIGHT: 'weight',
    WIDTH: 'width',
  },
};

export default PRODUCT;
